export const isCheckoutDisabled = ({
  isCartLoading = false,
  buyNowBtnDisabled = false,
  cartIsEmpty = false,
  hasAvailableTimeType = false,
  applePayCheckFailed = false,
} = {}) =>
  isCartLoading ||
  buyNowBtnDisabled ||
  cartIsEmpty ||
  hasAvailableTimeType ||
  applePayCheckFailed;
